export function teaserBlockAnimation() {
    const LETTER_INTERVAL = 40; // ms delay between letters
    const INDEX_DIVIDER = 2;
    const teaserBlocks = document.querySelectorAll(".pul-teaser-block");

    if (!teaserBlocks.length) return;

    teaserBlocks.forEach(teaserBlock => {
        const texts = teaserBlock.querySelectorAll("span[class^='pul-headline']");

        texts.forEach(text => {
            const letters = text.textContent.split("").map(letter => `<span class="animating">${letter}</span>`).join("");

            text.innerHTML = letters;

            const animatedLetters = teaserBlock.querySelectorAll(".animating");
            const observer = new IntersectionObserver(([entry], obs) => {
                if (entry.isIntersecting) {
                    animatedLetters.forEach((el, i) => {
                        setTimeout(() => {
                            el.classList.add("in-view");

                            if(i === animatedLetters.length - 1) {
                                teaserBlock.classList.add("completed");
                            }
                        }, (i / INDEX_DIVIDER) * LETTER_INTERVAL);
                    });

                    obs.unobserve(entry.target); // animate once
                }
            }, {
                threshold: window.matchMedia("(min-width: 768px)").matches ? 0.5 : 0.1,
            });

            observer.observe(teaserBlock);
        })
    });
}